export enum EnumEstadoLead {
    SinEvaluar = 1,
    EvaluacionSolicitada,
    Procesando,
    Evaluado,
    EvaluacionErronea,
    Publicado
}
